<template>
  <div class="schoolCardList-container div-layout">
    <module-title title="通用搜索模块资料">
      <div class="right">
        <el-button type="primary" size="medium" @click="commonSearchAddOrEdit('add')">
          添加
        </el-button>
      </div>
    </module-title>
    <div class="schoolCardList-right-contain">
      <el-form
        ref="subjectSearchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
        class="fl"
      >
        <el-form-item label="模块名称：" prop="name">
          <el-input
            v-model="searchForm.name"
            name="name"
            maxlength="50"
            placeholder="输入模块名称"
            class="edit-form-input"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="listLoading"
        :data="dataList"
        fit
        element-loading-text="Loading"
        class="list-table"
        highlight-current-row
      >
        <el-table-column type="index" width="55" align="center" label="序号" />
        <el-table-column label="模块名称" align="center" prop="name" />
        <el-table-column label="模块编码" align="center" prop="code" />
        <el-table-column label="模块图片" prop="param" align="attachmentPath">
          <template slot-scope="{ row }">
            <el-image
              style="width: 156px; height: 156px"
              :src="row.attachmentPath"
              :preview-src-list="[row.attachmentPath]"
            />
          </template>
        </el-table-column>
        <el-table-column label="参数" prop="param" align="center">
          <!-- 备注内容默认展现50个字符，鼠标悬浮可展示全部 -->
          <template slot-scope="{ row }">
            <span :title="row.param">{{ row.param | substring(20) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createDate" align="center" />
        <el-table-column label="操作" align="center" width="180px">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-edit"
              @click="commonSearchAddOrEdit('edit',scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              size="small"
              @click="commonSearchDetail(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 添加编辑 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="hiddenVariable.handleTitle==='add'?'添加':'编辑'"
      width="650px"
    >
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="模块名称：" prop="name">
          <el-input
            v-model="handleForm.name"
            name="name"
            maxlength="52"
            placeholder="请输入模块名称"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="模块编码：" prop="code">
          <el-input
            v-model="handleForm.code"
            name="code"
            maxlength="52"
            placeholder="请输入编码"
            class="handle-form-input"
            :disabled="hiddenVariable.handleTitle!=='add'"
          />
        </el-form-item>
        <el-form-item label="参数：" prop="param">
          <el-input
            v-model="handleForm.param"
            name="param"
            maxlength="52"
            placeholder="请输入参数"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="附件上传：" prop="attachmentPath">
          <div class="handle-form-input">
            <span>可支持JPG\PNG\GIF\JPEG类型建议上传{{ vueCropperImgProps.width * vueCropperImgProps.enlarge }}x{{ vueCropperImgProps.heigth * vueCropperImgProps.enlarge }}像素图片</span>
            <el-button size="small" type="primary" class="fr" @click="hiddenVariable.dialogcommonSearchVisible=true">
              点击上传
            </el-button>
          </div>
          <div class="picture-wrapper">
            <img v-if="handleForm.attachmentPath" :src="handleForm.attachmentPath" alt class="WHshow">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="hiddenVariable.dialogEditVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddcommonSearch"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="hiddenVariable.dialogcommonSearchVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogcommonSearchVisible"
      title="图片裁剪"
      append-to-body
      width="620px"
    >
      <vue-cropper-img
        :props-w-h="vueCropperImgProps"
        :size="10"
        @closeDialog="closeDialogFn"
      />
    </el-dialog>
  </div>
</template>

<script>

import {
  seachermodelsQuery,
  seachermodelsDetail,
  seachermodelsAdd,
  seachermodelsEdit,
  seachermodelsDel
} from '@/api/systemMaintenance/devicManage/commonSearch';
export default {
  name: 'CommonSearch',
  data() {
    const validateName = (rule, value, callback) => {
      const pattern = new RegExp(
        /^[\u4e00-\u9fa5A-Za-z]+$/
      );
      if (value === '') {
        callback(new Error('模块名称不能为空'));
      } else if (!pattern.test(value)) {
        callback(new Error('请输入中文或英文字符'));
      } else if (value.toString().length > 50) {
        callback(new Error('请输入50以内的字符'));
      } else {
        callback();
      }
    };
    return {
      dataList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        name: '',
        total: 0
      },
      listLoading: false,
      ajaxLoading: false,
      vueCropperImgProps: {
        width: 156,
        heigth: 156,
        size: 10,
        enlarge: 1
      },
      hiddenVariable: {
        dialogcommonSearchVisible: false,
        dialogEditVisible: false, // 添加编辑
        handleTitle: 'add',
        id: ''
      },
      handleForm: {
        attachmentPath: '',
        name: '',
        param: '',
        code: ''
      },
      handleRules: {
        name: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '模块编码不能为空', trigger: 'blur' }
        ],
        param: [
          { required: true, message: '参数不能为空', trigger: 'blur' },
          { max: 50, message: '请输入50以内的字符', trigger: 'blur' }
        ],
        attachmentPath: [
          { required: true, message: '附件上传不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.fetchdataList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchdataList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchdataList();
    },

    // 获取列表名单
    fetchdataList() {
      var option = {
        ...this.searchForm
      };
      delete option.total;
      seachermodelsQuery(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.dataList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.dataList = [];
          this.searchForm.total = 0;
        }
      });
    },
    // 添加加编辑
    commonSearchAddOrEdit(val, row) {
      this.hiddenVariable.dialogEditVisible = true;
      this.hiddenVariable.handleTitle = val;
      if (val === 'edit') {
        this.hiddenVariable.id = row.id;
        seachermodelsDetail(this.hiddenVariable.id)
          .then(result => {
            if (result.code === '0' && result.data) {
              this.handleForm = result.data;
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.handleForm = {
          name: '',
          param: '',
          attachmentPath: '',
          code: ''
        };
        this.hiddenVariable.id = '';
      }
    },
    commonSearchDetail(row) {
      this.hiddenVariable.commonSearchId = row.id;
      this.$confirm(`确定要删除该模块么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return seachermodelsDel(row.id);
        }).then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchdataList();
        })
        .catch(() => {});
    },
    handleSearchFilter() {
      this.fetchdataList();
    },
    closeDialogFn(val) {
      this.hiddenVariable.dialogcommonSearchVisible = false;
      this.$set(this.handleForm, 'attachmentPath', val.absolutePath);
      this.$refs.handleForm.validateField('attachmentPath');
      this.$forceUpdate();
    },
    // 添加确认
    handleAddcommonSearch() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          var op = {
            name: this.handleForm.name,
            param: this.handleForm.param,
            attachmentPath: this.handleForm.attachmentPath,
            code: this.handleForm.code
          };
          if (this.hiddenVariable.handleTitle === 'add') {
            seachermodelsAdd(op)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '新增成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchdataList();
              })
              .catch(err => {
                console.log(err);
              });
            this.ajaxLoading = false;
          } else {
            seachermodelsEdit(this.hiddenVariable.id, op)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchdataList();
              })
              .catch(err => {
                console.log(err);
              });
            this.ajaxLoading = false;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }

  }
};
</script>
<style lang="scss" scoped>
.schoolCardList-container{
  .fl{
    padding-left: 10px;
  }
}
.fr{ float: right !important; }
.WHshow{
  width: 156px;
}
</style>
